import { render, staticRenderFns } from "./SendPosterSummaryDialog.vue?vue&type=template&id=ce49bcb4"
import script from "./SendPosterSummaryDialog.vue?vue&type=script&lang=js"
export * from "./SendPosterSummaryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports